import React from "react";
import "../View.css";
import "../Grid.css";
import "../Form.css";
import "../App.css";
import ViewUtils from '../ViewUtils';
import EnhancedTable from '../widgets/ResponsiveTable';
import { Alert } from "react-bootstrap";
const utils = new ViewUtils();


export default function UnitStandardsTable(props) {
    const [TotalCredits, setTotalCredits] = React.useState(0);
    const [Credits, setCredits] = React.useState(0);
    const [MinimumElectiveCredits, setMinimumElectiveCredits] = React.useState(0);
    const [TotalElectiveCredits, setTotalElectiveCredits] = React.useState(0);

    const handleDataArrive = (data) => {
        setTotalCredits(data.TotalCredits);
        setCredits(data.Credits);
        setMinimumElectiveCredits(data.MinimumElectiveCredits);
        setTotalElectiveCredits(data.TotalElectiveCredits);

        if (!utils.isNull(props.onDataArrive)) {
            props.onDataArrive(data);
        }
    }

    const creditFuc = (TotalCredits, Credits) => {
        if (parseInt(TotalCredits) < parseInt(Credits)) { 
            return '50vh';
        }
           return '40vh';
    }

    return (
        <div className="view w-100">
            <div style={{ paddingBottom: "8px" }}>
                {(parseInt(TotalCredits) < parseInt(Credits) || (parseInt(TotalElectiveCredits) < parseInt(MinimumElectiveCredits) )) ?                   
                    <div style={{ color:'#ff0e25',fontSize:'13px'}}>
                Please note:The total credits must be equal or more than the minimum qualification credits, and elective credits must be equal or more than minimum elective credits.
                </div>              
                :null
                }
                <div> {Credits >= 0 ? 'Minimum Qualification Credits: ' + Credits : null} </div>           
                <div> {MinimumElectiveCredits > 0 ? 'Minimum Elective Credits: ' + MinimumElectiveCredits : null} </div>
                <div> {TotalCredits >= 0 ? 'Total Credits: ' + TotalCredits : null} </div>   
            </div>
            <EnhancedTable headCells={props.headCells} onSelectionChange={props.onSelectionChange}
                dataUrl={props.dataUrl} onDataArrive={(data) => { handleDataArrive(data) }}
                searchParameters={props.searchParameters} paged={!utils.isNull(props.paged) ? props.paged : false} />
        </div>
    );
}